var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plus" }, [
    _c("div", { staticClass: "top-box" }, [
      _c("div", { staticClass: "top-center" }, [
        _c("div", { staticClass: "head-box flex" }, [
          _c("div", { staticClass: "head-box-img-box" }, [
            _c("img", {
              staticClass: "head-box-img",
              attrs: { src: _vm.lawyerInfo.imgUlr || _vm.heading, alt: "" }
            }),
            _vm.lawyerInfo.vipNo
              ? _c("img", {
                  staticClass: "is-vip",
                  attrs: {
                    src: require("@/assets/imgs/plusPage/is-vip.png"),
                    alt: ""
                  }
                })
              : _vm._e()
          ]),
          _c("div", { staticClass: "head-right" }, [
            _c("p", { staticClass: "name" }, [
              _vm._v(
                _vm._s(_vm.lawyerInfo.realName) +
                  _vm._s(_vm.lawyerInfo.realName ? "，" : "") +
                  "您好！"
              )
            ]),
            _c("p", { staticClass: "head-info" }, [
              _vm._v(
                _vm._s(
                  _vm.lawyerInfo.vipNo ? "您已开通会员" : "您还不是长律PLUS会员"
                )
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "top-bottom flex" }, [
          _vm._m(0),
          _c("div", { staticClass: "bottom-right" }, [
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.lawyerInfo.vipNo
                    ? _vm.lawyerInfo.vipInvalidTime + "到期"
                    : "暂未开通"
                )
              )
            ])
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "content" }, [
      _c("div", [
        _c("img", {
          staticClass: "content-top",
          attrs: { src: require("@/assets/imgs/plusPage/add.png"), alt: "" }
        }),
        _c("div", { staticClass: "item-box" }, [
          _c(
            "div",
            { staticClass: "box flex" },
            _vm._l(_vm.privilegeList, function(item, index) {
              return _c("div", { key: item.privilegeId }, [
                _c(
                  "div",
                  {
                    staticClass: "item",
                    class:
                      index == _vm.privilegeList.length - 1 ? "last-child" : ""
                  },
                  [
                    _c("img", { attrs: { src: item.icon, alt: "" } }),
                    _c("p", { staticClass: "item-tilte" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _c("p", { staticClass: "item-info" }, [
                      _vm._v(_vm._s(item.description))
                    ])
                  ]
                )
              ])
            }),
            0
          )
        ])
      ]),
      _c("div", [
        _c("img", {
          staticClass: "content-top",
          attrs: {
            src: require("@/assets/imgs/plusPage/interests.png"),
            alt: ""
          }
        }),
        _c("div", { staticClass: "price-box flex" }, [
          _c(
            "div",
            { staticClass: "box flex" },
            _vm._l(_vm.cardList, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "price",
                  on: {
                    click: function($event) {
                      return _vm.changePrice(item)
                    }
                  }
                },
                [
                  _vm.lawyerInfo.vipNo
                    ? _c("div", { staticClass: "price-bgc" }, [
                        _c("p", { staticClass: "bgc-opacity price-bgc-1" })
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "price-bgc",
                          class:
                            _vm.isChange == item.item.id ? "price-border" : ""
                        },
                        [
                          _c("p", {
                            staticClass: "bgc-opacity",
                            class:
                              _vm.isChange != item.item.id ? "price-bgc-1" : ""
                          })
                        ]
                      ),
                  _c("p", { staticClass: "price-name" }, [
                    _vm._v(_vm._s(item.item.name))
                  ]),
                  _c("p", { staticClass: "price-present" }, [
                    _vm._v(
                      "¥ " + _vm._s(_vm.priceYuan(item.item.discountsPrice))
                    )
                  ]),
                  _c("p", { staticClass: "price-original" }, [
                    _vm._v(
                      "原价¥" + _vm._s(_vm.priceYuan(item.item.originalPrice))
                    )
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]),
    _vm.lawyerInfo.vipNo
      ? _c("div", { staticClass: "footer footer-color" }, [
          _c("p", { staticClass: "isVip" }, [_vm._v("已开通会员")])
        ])
      : _c("div", { staticClass: "footer flex footer-bgc" }, [
          _c("div", { staticClass: "footer-left flex" }, [
            _c("p", { staticClass: "price" }, [
              _vm._v(_vm._s(_vm.priceYuan(_vm.curItem.discountsPrice)))
            ]),
            _c("p", { staticClass: "name" }, [
              _vm._v("元/" + _vm._s(_vm.curItem.name))
            ])
          ]),
          _c("p", { staticClass: "submit", on: { click: _vm.submit } }, [
            _vm._v("立即开通")
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-left flex" }, [
      _c("img", {
        attrs: { src: require("@/assets/imgs/plusPage/crown.png"), alt: "" }
      }),
      _c("p", [_vm._v("长律PLUS会员")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }